import apiFetch from '../apiFetch'
export default function (ouId, token) {
  return apiFetch({ endPoint: `salesman/userHierarchyLogic?organizedUnitId=${ouId}`, method: 'GET', body: null, token: token })
}
